import React from "react"

import { Control } from "./styles"

const Pause = ({ onClick }) => {
  return (
    <Control type="button" onClick={() => onClick()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="32"
        width="32"
        viewBox="0 0 1200 1200"
      >
        <path d="M600 0C268.63 0 0 268.63 0 600s268.63 600 600 600 600-268.63 600-600S931.37 0 600 0zM330.835 289.38h181.714v621.24H330.835V289.38zm356.616 0h181.714v621.24H687.451V289.38z" />
      </svg>
    </Control>
  )
}

export default Pause
